import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

const Wrapper = styled(FlexBox)<{ flag: boolean }>`
    flex-flow: row;
    cursor: pointer;
    place-items: center;
    margin-bottom: 12px;
    margin-top: 2px;

    color: rgba(144, 144, 144, 1);
    font-size: 15px;
    line-height: 20px;

    svg {
        margin-left: 4px;
        transform: rotate(0deg);
        transition: transform 0.2s;
    }

    ${({ flag }) => flag && css`
        svg {
            transform: rotate(180deg);
            transition: transform 0.2s;
        }
    `};

@media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 13px;
    line-height: 16px;
}
`;

export const CollapseButton: FC<{
    onClick: () => void,
    flag: boolean
}> = ({ onClick, flag }) => {
    const { t } = useTranslation();

    return (
        <Wrapper flag={flag} onClick={onClick}>
            <div>{t(`${flag ? 'collapse' : 'show_more_text'}`).toLowerCase()}</div>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 7.61851L1.89987 3.1676C1.69401 2.94413 1.36025 2.94413 1.15439 3.16761C0.948535 3.39108 0.948537 3.7534 1.1544 3.97687L5.62726 8.8324C5.83312 9.05587 6.16688 9.05587 6.37274 8.8324L10.8456 3.97687C11.0515 3.7534 11.0515 3.39108 10.8456 3.16761C10.6398 2.94413 10.306 2.94413 10.1001 3.1676L6 7.61851Z" fill="#909090"/>
            </svg>
        </Wrapper>
    )
}import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";

const Wrapper = styled(FlexBox)<{ flag: boolean }>`
    flex-flow: row;
    cursor: pointer;
    place-items: center;
    margin-bottom: 12px;
    margin-top: 2px;

    color: rgba(144, 144, 144, 1);
    font-size: 15px;
    line-height: 20px;

    svg {
        margin-left: 4px;
        transform: rotate(0deg);
        transition: transform 0.2s;
    }

    ${({ flag }) => flag && css`
        svg {
            transform: rotate(180deg);
            transition: transform 0.2s;
        }
    `};

@media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 13px;
    line-height: 16px;
}
`;

export const CollapseButton: FC<{
    onClick: () => void,
    flag: boolean
}> = ({ onClick, flag }) => {
    const { t } = useTranslation();

    return (
        <Wrapper flag={flag} onClick={onClick}>
            <div>{t(`${flag ? 'collapse' : 'show_more_text'}`).toLowerCase()}</div>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 7.61851L1.89987 3.1676C1.69401 2.94413 1.36025 2.94413 1.15439 3.16761C0.948535 3.39108 0.948537 3.7534 1.1544 3.97687L5.62726 8.8324C5.83312 9.05587 6.16688 9.05587 6.37274 8.8324L10.8456 3.97687C11.0515 3.7534 11.0515 3.39108 10.8456 3.16761C10.6398 2.94413 10.306 2.94413 10.1001 3.1676L6 7.61851Z" fill="#909090"/>
            </svg>
        </Wrapper>
    )
}